import CarbonCoefType from "@/model/CarbonCoefType"
import Ship from "@/model/Ship"
import ShipType from "@/model/ShipType"
import { shipTypeCodes } from "../utils/constants"
import CalcAttainedEEXIService from "./CalcAttainedEEXIService"
import ParametricTableService from "./ParametricTableService"
import utils from "@/utils/configuration/config.js"
import Configuration from "@/model/Configuration"
import ConfigurationForCarbonType from "@/model/ConfigurationForCarbonType"

class CalcCarbonIndexIndicatorService {
    private static instance

    private constructor() {}

    public static getInstance() {
        if (!this.instance) {
            this.instance = new CalcCarbonIndexIndicatorService()
        }
        return this.instance
    }

    private find_carbon_coef(dwt: number, gt: number, shipType: ShipType, highSpeedCruise: boolean) {
        let valueToUse = dwt
        if (shipType.code === shipTypeCodes.ROROCargo) {
            // Para los ROROCargo en vez de el dwt se utiliza el gt
            valueToUse = gt
        } else if (shipType.code === shipTypeCodes.ROPAX) {
            // Es un caso especial para ROPAX solo se mira si es highSpeed o no lo es
            valueToUse = highSpeedCruise ? 15 : 5
            // console.log(
            //     "CalcCarbonIndexIndicatorService.find_carbon_coef. highSpeedCruise =",
            //     highSpeedCruise,
            //     ". valueToUse =",
            //     valueToUse
            // )
        }

        // console.log(
        //     "CalcCarbonIndexIndicatorService.carbon_coefs_objects",
        //     dwt,
        //     shipType,
        //     shipType.carbon_coefs_objects
        // )
        let result: CarbonCoefType | null = null
        shipType.carbon_coefs_objects.forEach((carbonCoefObj) => {
            if (carbonCoefObj.min_dwt <= valueToUse) {
                if (carbonCoefObj.max_dwt == -1 || carbonCoefObj.max_dwt > valueToUse) {
                    result = carbonCoefObj
                }
            }
        })

        //console.log("CalcCarbonIndexIndicatorService.carbon_coefs_objects. result =", result)

        return result
    }

    private calcCapacity(dwt: number, gt: number, shipType: ShipType) {
        let result = dwt

        if (shipType.code === shipTypeCodes.BulkCarrier && dwt >= 279000) {
            result = 279000
        } else if (shipType.code === shipTypeCodes.LNG && dwt < 65000) {
            result = 65000
        } else if (
            shipType.code === shipTypeCodes.RORO ||
            shipType.code === shipTypeCodes.ROROCargo ||
            shipType.code === shipTypeCodes.ROPAX ||
            shipType.code === shipTypeCodes.Passengers
        ) {
            result = gt
        }

        return result
    }

    public calcCarbonIndexIndicatoForShip(ship: Ship) {
        //console.log("CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip - SHIP:", ship)
        const parametricTables = ParametricTableService.getInstance().getParametricTable(
            utils.config.firebaseConfig.parametricVersion
        )

        const capacity = this.calcCapacity(ship.dwt, ship.gt, ship.shipType)
        //console.log("CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip. capacity =", capacity)
        const carbonCoefType: CarbonCoefType | null = this.find_carbon_coef(
            ship.dwt,
            ship.gt,
            ship.shipType,
            ship.highSpeedCruise
        )
        let ciiref: number
        const attainedcii = new Array<number>()

        if (carbonCoefType != null && parametricTables) {
            const carbonCoefTypeDef: CarbonCoefType = carbonCoefType

            // console.log(
            //     "CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip. carbonCoefTypeDef =",
            //     carbonCoefTypeDef
            // )

            ciiref = carbonCoefTypeDef.a * Math.pow(capacity, -1 * carbonCoefTypeDef.c)
            // console.log(
            //     "CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip.  carbonCoefTypeDef.a =",
            //     carbonCoefTypeDef.a
            // )
            // console.log(
            //     "CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip.  carbonCoefTypeDef.c =",
            //     carbonCoefTypeDef.c
            // )

            ship.carbonData.requiredcii = new Array<number>()

            ship.carbonData.configurationsForCarbon.forEach((configuration) => {
                const capacity_for_this_config = this.get_capacity_for_this_configuration(configuration, ship)

                configuration.resultsForConfiguration = new Array<string>()
                let attainedciiForConfig = 0
                configuration.fuelInfo.forEach((fuelInfo) => {
                    const cf = CalcAttainedEEXIService.get_value_for_fuel_type(
                        "CF",
                        fuelInfo.fuelCode,
                        parametricTables,
                        new Array<string>()
                    )

                    const lcv = CalcAttainedEEXIService.get_value_for_fuel_type(
                        "LCV",
                        fuelInfo.fuelCode,
                        parametricTables,
                        new Array<string>()
                    )

                    // Consumo en toneladas por defecto
                    let fuelConsumptionPerYear = fuelInfo.fuelConsumptionPerYear * 1000000
                    if (!fuelInfo.consumptionInTons) {
                        fuelConsumptionPerYear = (fuelInfo.fuelConsumptionPerYear * 3600 * 1000000) / lcv
                    }

                    // console.log(
                    //     "CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip. sumatorio: ",
                    //     attainedciiForConfig,
                    //     fuelConsumptionPerYear,
                    //     cf
                    // )
                    attainedciiForConfig += fuelConsumptionPerYear * cf
                    // console.log(
                    //     "CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip. resultado parcial: ",
                    //     attainedciiForConfig
                    // )
                })
                // console.log(
                //     "CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip. valores: ",
                //     attainedciiForConfig,
                //     capacity_for_this_config,
                //     ship.carbonData.distancePerYear
                // )
                attainedciiForConfig =
                    attainedciiForConfig / (capacity_for_this_config * ship.carbonData.distancePerYear)
                // console.log(
                //     "CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip. attainedciiForConfig =",
                //     attainedciiForConfig
                // )
                configuration.attainedcii = attainedciiForConfig
            })

            let year = 0
            const yearsToCalc = 5
            while (year < yearsToCalc) {
                //console.log("CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip. year =", year)
                const zt = parametricTables["carbonReductionFactor"][year]
                //console.log("CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip. zt =", zt)
                //console.log("CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip. ciiref =", ciiref)
                const actualRequiredcii = ((100 - zt) / 100) * ciiref
                // console.log(
                //     "CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip. actualRequiredcii =",
                //     actualRequiredcii
                // )
                ship.carbonData.requiredcii.push(actualRequiredcii)

                ship.carbonData.configurationsForCarbon.forEach((configuration) => {
                    let carbonCoefTypeForThisConfig: CarbonCoefType | null = this.find_carbon_coef_for_this_config(
                        configuration,
                        ship
                    )
                    carbonCoefTypeForThisConfig =
                        carbonCoefTypeForThisConfig != null ? carbonCoefTypeForThisConfig : carbonCoefTypeDef

                    const resultSimpleResult = this.calcSimpleResultForAttainedcii(
                        ship.carbonData.requiredcii[year],
                        configuration.attainedcii,
                        carbonCoefTypeForThisConfig
                    )

                    // console.log(
                    //     "CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip. resultSimpleResult =",
                    //     resultSimpleResult
                    // )
                    configuration.resultsForConfiguration.push(resultSimpleResult)
                })

                year += 1
            }
        }
        //console.log("CalcCarbonIndexIndicatorService.calcCarbonIndexIndicatoForShip. Result=", ship.carbonData)
    }

    
    find_carbon_coef_for_this_config(configuration: ConfigurationForCarbonType, ship: Ship): CarbonCoefType | null {
        const gt_to_use = configuration.modified_gt != 0 ? configuration.modified_gt : ship.gt
        const dwt_to_use = configuration.modified_dwt != 0 ? configuration.modified_dwt : ship.dwt

        return this.find_carbon_coef(dwt_to_use, gt_to_use, ship.shipType, ship.highSpeedCruise)
    }

    private get_capacity_for_this_configuration(configuration: ConfigurationForCarbonType, ship: Ship) {
        const gt_to_use = configuration.modified_gt != 0 ? configuration.modified_gt : ship.gt
        const dwt_to_use = configuration.modified_dwt != 0 ? configuration.modified_dwt : ship.dwt

        return this.calcCapacity(dwt_to_use, gt_to_use, ship.shipType)
    }

    private calcSimpleResultForAttainedcii(
        requiredcii: number,
        attainedcii: number,
        carbonCoefType: CarbonCoefType
    ): string {
        if (attainedcii < requiredcii * carbonCoefType.d1) {
            return "A"
        } else if (attainedcii < requiredcii * carbonCoefType.d2) {
            return "B"
        } else if (attainedcii < requiredcii * carbonCoefType.d3) {
            return "C"
        } else if (attainedcii < requiredcii * carbonCoefType.d4) {
            return "D"
        }
        return "E"
    }
}

export default CalcCarbonIndexIndicatorService
